import type { FaireProductEntity } from "../../entity_types/product";

export const p_f3zz554kt6: FaireProductEntity = {
  token: "p_f3zz554kt6",
  type: "product",
  name: "Kris Nylon Multi Compartment Travel Weekender",
  brandToken: "b_7yc0xhlyll",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/be7aeb7b71027454d0a3ad959d52c1dd14eca2c931ee258911cb0998b4bcdb1a.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/6bb21cadd3a7ee823cbea12fdcd43474e05f544c71d9bbe16af162afc0251401.jpeg",
    "https://cdn.faire.com/fastly/14b14e8623980b2233d12c6a31c3426d012510a5b4600acff59984ac112c1527.jpeg",
    "https://cdn.faire.com/fastly/ee4cf22f466de99bba9c047754a7f6406a57a1497ede9c071ac6cbda9ccd64b6.jpeg",
    "https://cdn.faire.com/fastly/cbb25d47ffbbcaf4c1cce8e4b89087ab49c85fb7111f0a232ca816d2769dc4e3.jpeg",
    "https://cdn.faire.com/fastly/261586289fa7ce2dfc55790a0970b3ea49866d86481c75ee3b249c85712c868d.jpeg",
    "https://cdn.faire.com/fastly/32698fe6313e9bde9a0bd782e7949976ebdbcac24c7bbe72e392400d8aad3128.jpeg",
    "https://cdn.faire.com/fastly/950c24a606ae6aaf33083a9a0fe3a479c3869bdb4878ffe764fcc50f650159d3.jpeg",
    "https://cdn.faire.com/fastly/69e3a2779b2aee12a876e94cc30b86326f7a8dff89fd9e30940e7d5cc069d53c.jpeg",
    "https://cdn.faire.com/fastly/b3ede8adba332b4589f65ed35a6ad4a84060290e25eda29a50ff82fd4307ec2a.jpeg",
    "https://cdn.faire.com/fastly/8a1b1595dfc9f4f37cc2e4b463b802bb818973c2770a2eb6afc0f53b104fb7fb.jpeg",
    "https://cdn.faire.com/fastly/2e1aabf6bfa0270e54c2df0a7e721ed07819e93775c32a7734700cbbc942094e.jpeg",
    "https://cdn.faire.com/fastly/3090a11940e3a4c25997136cc50c640dd4c7621421368152ae485c31d5d96a1e.jpeg",
    "https://cdn.faire.com/fastly/5260becc40ebb124908c67dc6ce273196babc8f5f911d22c14f250191d4e0504.jpeg",
    "https://cdn.faire.com/fastly/c1bb401838c4e86066d116bdfbcba80c61a274c0df14ebd51ef955133941937b.jpeg",
    "https://cdn.faire.com/fastly/12169f7ac637aad49bc7b4bfd331ac2ab4b30ec98a092d49117b6d48dd4932f5.jpeg",
    "https://cdn.faire.com/fastly/51c26c73ee4d63472aa9cc2b4d5e0532d92a4c76af4508c927f2310efcc8d1ac.jpeg",
    "https://cdn.faire.com/fastly/08ce97d35787f827093759c39aba56234b320be01fa20d1184afc391aacdb376.jpeg",
    "https://cdn.faire.com/fastly/e0869c4f41b4e8b18aa7ba89a7408f01925cb1878733a735537014442089f8f1.jpeg",
    "https://cdn.faire.com/fastly/f628797024117f1df7590a1e5d746194246dfb1e3691864fb647aa8c99113ddc.jpeg",
    "https://cdn.faire.com/fastly/416ac6f69b26477bfa1b951ef00302549c395f05b4c32b0b21599b721232b744.jpeg",
    "https://cdn.faire.com/fastly/ffacb2fada9f6f9b4fd8b6483c691154de338f19b7d81e2b9c7393714073acfd.jpeg",
    "https://cdn.faire.com/fastly/a11a7672586a0803d64adb12d60307d9792788c5d9a5aa36ff9297f20486fcce.jpeg",
    "https://cdn.faire.com/fastly/185fe77ca4c2f9659222b15241106457d4fd3a823927ce5904425b01d3a34450.jpeg",
  ],
  priceDollars: 55.43,
  description:
    "Crafted from durable nylon, this tote comes with sleek tonal hardware and handy pull tabs for easy access. It features an adjustable and detachable shoulder strap for ultimate comfort. The best part? It includes a dedicated shoe compartment—perfect for keeping your kicks separate from the rest of your gear. Inside, you'll find a nylon fabric lining with a zip mesh pocket and two slip pockets to keep all your essentials organized. Whether you're heading to the gym or out on errands, this tote has got you covered!\n\n*Item Type: Tote\n*Material: Nylon\n*Closure: Zipper\n*Exterior Details: Tonal Hardware, Pull Tabs, Adjustable/Detachable Shoulder Strap, Shoe Compartment\n*Interior Details: Nylon Fabric Lined, 1 Zip Mesh Pocket, 2 Slip Pockets",
  tags: [],
  msrpDollars: 110.85,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:25:35.840Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
